import { createRouter, createWebHistory } from 'vue-router';
import MainMenu from "@/components/MainMenu";
import LigatureComponent from "@/components/calculators/ligature/LigatureComponent";
import LongRing from "@/components/calculators/longRingComponent/LongRing";
import ChainsComponent from "@/components/calculators/chains/ChainsComponent";
import SoldiersComponent from "@/components/calculators/soldiers/SoldiersComponent";
import HalfSphere from "@/components/calculators/halfSphere/HalfSphere"
import cylinderComponent from "@/components/calculators/cylinder/cylinderComponent"
import VolumeWeight from "@/components/calculators/volumeWeight/VolumeWeight"
import WaxWeight from "@/components/calculators/waxWeight/WaxWeight"
import AssayMix from "@/components/calculators/assayMix/AssayMix"
import achievements from "@/components/achievements/AchievementsMain"
import partners from "@/components/partners/partners"
import LegalPage from "@/components/LegalPage"

const routes = [
    {
        path: '/',
        name: 'MainMenu',
        component: MainMenu,
        meta: {
            title: 'Ювелирные калькуляторы онлайн — расчёт веса, пробы и металла',
            description: 'Бесплатные ювелирные калькуляторы для мастеров: лигатура, припой, цепочки, шинка, трубка, восковка, вес по объёму и смешивание проб.',
        },
    },
    {
        path: '/ligature',
        name: 'LigatureComponent',
        component: LigatureComponent,
        meta: { title: 'Расчёт лигатуры онлайн — ювелирный калькулятор', description: 'Онлайн-расчёт состава, общего веса и стоимости лигатуры для серебряных и золотых сплавов.' },
    },
    {
        path: '/longRing',
        name: 'LongRing',
        component: LongRing,
        meta: { title: 'Расчёт длины и веса шинки онлайн', description: 'Ювелирный калькулятор длины, объёма и веса шинки с учётом формы сечения, размера и плотности металла.' },
    },
    {
        path: '/chains',
        name: 'Chains',
        component: ChainsComponent,
        meta: { title: 'Расчёт ювелирной цепочки онлайн', description: 'Расчёт диаметра проволоки, ригеля, веса, припоя и стоимости для популярных плетений золотых и серебряных цепей.' },
    },
    {
        path: '/soldiers',
        name: 'Soldiers',
        component: SoldiersComponent,
        meta: { title: 'Расчёт ювелирного припоя онлайн', description: 'Онлайн-калькулятор состава, веса и стоимости припоя для серебряных и золотых сплавов.' },
    },
    {
        path: '/halfSphere',
        name: 'halfSphere',
        component: HalfSphere,
        meta: { title: 'Расчёт заготовки полусферы онлайн', description: 'Калькулятор диаметра плоской заготовки для изготовления ювелирной полусферы.' },
    },
    {
        path: '/cylinder',
        name: 'cylinder',
        component: cylinderComponent,
        meta: { title: 'Расчёт заготовки для трубки онлайн', description: 'Онлайн-расчёт ширины заготовки ювелирной трубки по диаметру и толщине металла.' },
    },
    {
        path: '/volumeWeight',
        name: 'VolumeWeight',
        component: VolumeWeight,
        meta: { title: 'Расчёт веса металла по объёму онлайн', description: 'Калькулятор веса золота и серебра по объёму, плотности и пробе металла.' },
    },
    {
        path: '/waxWeight',
        name: 'WaxWeight',
        component: WaxWeight,
        meta: { title: 'Расчёт веса металла по восковке онлайн', description: 'Онлайн-калькулятор веса металла по массе восковой модели, плотности сплава и технологическому коэффициенту.' },
    },
    {
        path: '/assayMix',
        name: 'AssayMix',
        component: AssayMix,
        meta: { title: 'Калькулятор смешивания проб золота и серебра', description: 'Расчёт количества лигатуры или металла для получения сплава нужной пробы.' },
    },
    {
        path: '/achievements',
        name: 'achievements',
        component: achievements,
        meta: { title: 'Достижения пользователя', description: 'Персональные достижения в ювелирном калькуляторе.', noindex: true },
    },
    {
        path: '/partners',
        name: 'partners',
        component: partners,
        meta: { title: 'Партнёры ювелирного калькулятора', description: 'Полезные сервисы и партнёры проекта ювелирных калькуляторов.' },
    },
    { path: '/privacy', name: 'privacy', component: LegalPage, meta: { title: 'Политика конфиденциальности', description: 'Политика обработки данных пользователей ювелирного калькулятора.', noindex: true } },
    { path: '/terms', name: 'terms', component: LegalPage, meta: { title: 'Пользовательское соглашение', description: 'Условия использования сервиса ювелирных калькуляторов.', noindex: true } },

]

const router = createRouter({
    history: createWebHistory('/'),
    routes,
});

export default router;
